import { useEffect, useState } from 'react';
import { goApi } from '../services';
import { apiRoutes } from '../services/apiRoutes';

const useTestLanguages = () => {
    const [languages, setLanguages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const getLanguages = async () => {
        try {
            const data = await goApi.get(apiRoutes.TEST_SERIES_LANGUAGES);
            setLanguages(data?.data || []);
        } catch (err: any) {
            setError(err.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getLanguages();
    }, []);

    return { languages, loading, error };
};

export default useTestLanguages;
